export function SelectedOverlay() {
  return (
    <div className="absolute z-10 top-0 left-0 w-full h-full border border-edit-border pointer-events-none" />
  );
}
